module.exports = __webpack_public_path__ + "static/img/12.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/12.png
// module id = vF6o
// module chunks = 0